import styled from '@emotion/styled';

export const MainWrapper = styled.div`
  background: ${'#8E1558'};
`;
